import { api } from "../api";

export type PdcProcessPayload = {
  requiresPowerOfAttorney?: boolean;
  homologationProcess?: string;
  inspectionProcess?: string;
  deadlines?: string;
  commonRejections?: string;
  requiredDocuments?: string;
  generalNotes?: string;
};

export type PdcCredentialPayload = {
  platformName: string;
  url?: string;
  login?: string;
  password?: string;
  linkedEmail?: string;
  notes?: string;
};

export type PdcLinkPayload = {
  title: string;
  url: string;
  category?: string;
  notes?: string;
};

export type PdcDocumentPayload = {
  title: string;
  externalUrl?: string;
  category?: string;
  notes?: string;
  fileId?: string | null;
  fileName?: string | null;
  fileSize?: number | null;
  fileWebUrl?: string | null;
};

export type PdcCommentPayload = {
  type?: string;
  content: string;
};

export const getPdcHub = async (pdcId: number) => {
  return api.get(`/pdc/${pdcId}/hub`);
};

export const updatePdcProcess = async (pdcId: number, data: PdcProcessPayload) => {
  return api.put(`/pdc/${pdcId}/process`, data);
};

export const createPdcCredential = async (pdcId: number, data: PdcCredentialPayload) => {
  return api.post(`/pdc/${pdcId}/credentials`, data);
};

export const updatePdcCredential = async (
  pdcId: number,
  credentialId: number,
  data: PdcCredentialPayload
) => {
  return api.put(`/pdc/${pdcId}/credentials/${credentialId}`, data);
};

export const deletePdcCredential = async (pdcId: number, credentialId: number) => {
  return api.delete(`/pdc/${pdcId}/credentials/${credentialId}`);
};

export const revealPdcCredentialPassword = async (
  pdcId: number,
  credentialId: number,
  action: "VIEWED" | "COPIED" = "VIEWED"
) => {
  return api.post(`/pdc/${pdcId}/credentials/${credentialId}/reveal`, { action });
};

export const createPdcLink = async (pdcId: number, data: PdcLinkPayload) => {
  return api.post(`/pdc/${pdcId}/links`, data);
};

export const updatePdcLink = async (pdcId: number, linkId: number, data: PdcLinkPayload) => {
  return api.put(`/pdc/${pdcId}/links/${linkId}`, data);
};

export const deletePdcLink = async (pdcId: number, linkId: number) => {
  return api.delete(`/pdc/${pdcId}/links/${linkId}`);
};

export const createPdcDocument = async (pdcId: number, data: PdcDocumentPayload) => {
  return api.post(`/pdc/${pdcId}/documents`, data);
};

export const updatePdcDocument = async (
  pdcId: number,
  documentId: number,
  data: PdcDocumentPayload
) => {
  return api.put(`/pdc/${pdcId}/documents/${documentId}`, data);
};

export const deletePdcDocument = async (pdcId: number, documentId: number) => {
  return api.delete(`/pdc/${pdcId}/documents/${documentId}`);
};

export const getPdcDocumentFileDownloadUrl = async (fileId: string) => {
  const response = await api.get(`/files/download/${encodeURIComponent(fileId)}`);
  return response.data;
};

export const createPdcComment = async (pdcId: number, data: PdcCommentPayload) => {
  return api.post(`/pdc/${pdcId}/comments`, data);
};

export const deletePdcComment = async (pdcId: number, commentId: number) => {
  return api.delete(`/pdc/${pdcId}/comments/${commentId}`);
};
